import { Component, EventEmitter, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';

import { RtAnalyticsModule } from '@core/analytics-legacy';
import { FollowButtonComponent } from '@core/candidate-ui';
import { injectOpenJobEditor } from '@core/offers-logic';
import { JobEditorDialogTab, OfferStatus, ViewsOffer } from '@core/offers-types';
import { GroupComponent, IconButtonComponent } from '@core/user-interface-legacy';
import { JobsAnalytics } from '@recruitee/offers-legacy';
import { JobActionsDropdownContainerComponent } from '@recruitee/offers-smart-ui';
import { JobActionsDropdownType } from '@recruitee/offers-types';

/*
 eslint-disable
 @typescript-eslint/consistent-type-assertions,
 @angular-eslint/no-inputs-metadata-property,
 @angular-eslint/no-outputs-metadata-property,
*/

@Component({
  imports: [
    GroupComponent,
    IconButtonComponent,
    RtAnalyticsModule,
    FollowButtonComponent,
    RouterLink,
    JobActionsDropdownContainerComponent,
  ],
  templateUrl: './row-actions-cell.component.html',
  styleUrls: ['./row-actions-cell.component.less'],
  inputs: RowActionsCellComponent.NgInputs,
  outputs: RowActionsCellComponent.NgOutputs,
  changeDetection: ChangeDetectionStrategy.Eager,
  host: {
    '(click)': '$event.stopImmediatePropagation()',
  },
})
export class RowActionsCellComponent {
  public static NgInputs = [
    'offer' as const,
    'canPromoteSection' as const,
    'canManageJobs' as const,
    'followLoading' as const,
  ];
  public static NgOutputs = ['toggleFollow' as const];

  private readonly jobsAnalytics = inject(JobsAnalytics);
  private readonly openJobEditor = injectOpenJobEditor();

  protected readonly JobActionsDropdownType = JobActionsDropdownType;

  public offer: ViewsOffer;
  public followLoading: boolean;
  public canPromoteSection: boolean;
  public canManageJobs: boolean;

  public toggleFollow = new EventEmitter<ViewsOffer>();

  protected get hasPromote(): boolean {
    return (
      this.canPromoteSection &&
      (this.offer.status === OfferStatus.Published || this.offer.status === OfferStatus.Internal)
    );
  }

  protected get hasEdit(): boolean {
    return this.canManageJobs && this.offer.status !== OfferStatus.Archived;
  }

  protected editOffer() {
    const status = this.offer.status === OfferStatus.Published ? 'public' : this.offer.status;
    this.jobsAnalytics.trackEdit(status);

    this.openJobEditor(this.offer.id, JobEditorDialogTab.JobDetails);
  }
}
